import React from 'react';
import SimplePage from '../../pages/SimplePage';

export default function PoliciesPage() {
  return <SimplePage title="Policies" subtitle="Policies and coverage information." />;
}
